<template>
  <footer class="page-footer d-flex items-center justify-center py-[15px] max-ml:pb-[6rem]">
    <PageContentCenter class="text-[14px] md:flex flex-col gap-x-4">
      <p class="text-center max-ml:text-left! max-ml:px-[1rem]">
        Copyright © 2026 湖南和贵网络科技有限公司 All Rights Reserved.
      </p>
      <p class="text-center max-ml:text-left! max-ml:px-[1rem]">
        <!-- public/ 下的静态资源使用绝对路径引用，避免被 Vite 当作模块解析 -->
        <a class="hover:text-primary mr-[6px]" rel="noopener noreferrer" href="http://beian.miit.gov.cn/"
          target="_blank">湘ICP备19019122号-2</a>

        <Pic class="mr-[4px] inline-block w-[14px] h-[14px] align-[-2px] mt-[-4px] " src="/images/pages/police.png"
          alt="全国互联网安全管理服务平台" />

        <a class="hover:text-primary" href="https://beian.mps.gov.cn/#/query/webSearch?code=43010402002417"
          rel="noreferrer" target="_blank">湘公网安备43010402002417号</a>


        <a href="https://www.12377.cn/" target="_blank" rel="noopener noreferrer"
          class="hover:text-primary">&nbsp;&nbsp;&nbsp;违法和不良信息举报中心</a>
      </p>
    </PageContentCenter>
  </footer>
</template>

<style lang="scss" scoped>
.page-footer {
  width: 100vw;
  background: #111e2f;
  color: #b9bfc7;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  text-align: center;
  text-transform: none;
  // padding-bottom: constant(safe-area-inset-bottom);
  // /* 旧版 */
  // padding-bottom: env(safe-area-inset-bottom);
  /* 新版 */
}
</style>
